import common from './common.js'
// eslint-disable-next-line
const itemPath = require.context('../form', true, /^\.\/[^\/]+\/index\.js$/)
const items = itemPath.keys().map((path) => {
  const item = itemPath(path)
  return item.default || item
}) as any[]

export default items.concat(common)
